import ReactDOM from 'react-dom';
import React from 'react';

import loadTranslations from '@utils/localeSetup';
import Competitions from './Competitions';

(async () => {
  const rootElement = document.getElementById('competitions-root');
  await loadTranslations();

  if (rootElement) {
    ReactDOM.render(<Competitions />, rootElement);
  }
})();
